import { API_BASE } from '../config';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import AdminSurveyManagePageLeft from './AdminSurveyManagePageLeft';
import AdminSurveyManagePageRight from './AdminSurveyManagePageRight';
import './pages.css';
const socket = io(API_BASE || undefined);


const AdminSurveyManagePage = () => {
    const [surveys, setSurveys] = useState([]);
    const [newSurvey, setNewSurvey] = useState({ title: '', description: '' });
    const [selectedSurveyId, setSelectedSurveyId] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [newQuestion, setNewQuestion] = useState({
        question_text: '',
        question_explain: '',
        question_type_id: '',   // ✅ 올바른 필드명
        options: [],
        max_score: 5,
        step: 0.5,
        required: false,
        includeEtc: false       // ✅ "기타" 체크박스를 위한 필드
        });
    const [questionTypes, setQuestionTypes] = useState([]);
    const [allSites, setAllSites] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState('');
    const navigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    };

    
    useEffect(() => {
        fetchSurveys(); // 첫 로딩 시 불러오기
        fetchQuestionTypes(); // 문항 유형 불러오기
        fetchSites(); // 사이트 유형 불러오기
        fetchPrograms();

    socket.on('surveyUpdated', fetchSurveys); // 실시간 반영
    document.body.classList.add('admin-page-bg');

    return () => {

        socket.off('surveyUpdated', fetchSurveys); // 정리(cleanup)
        document.body.classList.remove('admin-page-bg');

    };
    }, []);


    const fetchPrograms = async () => {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_BASE}/api/programs`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        setPrograms(res.data || []);
    };

    const fetchSites = async () => { //전체 사이트 불러오기
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_BASE}/api/sites`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            });
            setAllSites(res.data); // site_id, site_name
        } catch (err) {
            console.error('❌ 사이트 목록 불러오기 실패:', err);
        }
        };


    const fetchQuestionTypes = async () => { // 문항 유형 불러오기기
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_BASE}/api/question-types`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
            });
            setQuestionTypes(res.data);
        } catch (err) {
            console.error('❌ 문항 유형 불러오기 실패:', err);
        }
    };

    const fetchSurveys = async () => {
        try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_BASE}/api/surveys/full`, {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        });
        setSurveys(res.data);
        } catch (err) {
        console.error('❌ 설문 목록 불러오기 실패:', err);
        if (err.response?.status === 401) {
            alert('로그인이 필요합니다.');
        }
        }
    };

    const createSurvey = async () => {
        try {
        const token = localStorage.getItem('token');
        await axios.post(`${API_BASE}/api/surveys`, newSurvey, {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        });
        setNewSurvey({ title: '', description: '' });
        fetchSurveys();
        } catch (err) {
        console.error('❌ 설문 생성 실패:', err);
        alert('권한이 없거나 로그인이 만료되었습니다.');
        }
    };
    
    const updateSurvey = async (surveyId, updatedData) => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${API_BASE}/api/surveys/${surveyId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            alert('✅ 설문이 수정되었습니다.');
            fetchSurveys(); // 목록 새로고침
            if (surveyId === selectedSurveyId) {
                selectSurvey(surveyId); // 현재 선택된 설문이면 질문도 새로고침
            }
        } catch (err) {
            console.error('❌ 설문 수정 실패:', err);
            alert('수정 중 오류가 발생했습니다.');
        }
    };

    const deleteSurvey = async (surveyId) => {
        if (!window.confirm('정말 이 설문을 삭제하시겠습니까?')) return;

        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${API_BASE}/api/surveys/${surveyId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            alert('✅ 설문이 삭제되었습니다.');
            if (surveyId === selectedSurveyId) {
                setSelectedSurveyId(null);     // 선택된 설문 초기화
                setQuestions([]);              // 질문 목록 초기화
            }
            fetchSurveys(); // 목록 갱신
        } catch (err) {
            console.error('❌ 설문 삭제 실패:', err);
            alert('삭제 중 오류가 발생했습니다.');
        }
    };

    const selectSurvey = async (surveyId) => {
        try {
            const token = localStorage.getItem('token');
            setSelectedSurveyId(surveyId);
            const res = await axios.get(`${API_BASE}/api/surveys/full`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const selected = res.data.find(s => s.survey_id === surveyId);
            setQuestions(selected.questions || []);
        } catch (err) {
            console.error('❌ 문항 조회 실패:', err);
            alert('조회 중 오류 발생');
        }
    };


const addQuestion = async () => {
    try {
        const token = localStorage.getItem('token');

        
        // 문항 유형이 선택되지 않으면 경고 메시지 출력
        if (!newQuestion.question_type_id) {
            alert('문항 유형을 선택해주세요.');
            return; // 함수 종료
        }

        // ✅ 옵션 정리: "기타"를 항상 마지막에 한 번만 유지
        let finalOptions = [...(newQuestion.options || [])];

        // "기타" 제거
        finalOptions = finalOptions.filter(opt => opt !== '기타');

        // "기타" 체크되었다면 맨 끝에 추가
        if (newQuestion.includeEtc) {
            finalOptions.push('기타');
        }

        const payload = {
        question_text: newQuestion.question_text,
        question_explain: newQuestion.question_explain || '',
        question_type_id: newQuestion.question_type_id,
        order_index: questions.length + 1,
        options: finalOptions, // ✅ 여기 반영
        max_score: newQuestion.max_score !== undefined ? newQuestion.max_score : 5,
        step: newQuestion.step !== undefined ? newQuestion.step : 0.5,
        required: newQuestion.required || false,  // 필수여부
        correct_answer: newQuestion.correct_answer || null // 정답이 있을 경우 추가
        };

        await axios.post(
        `${API_BASE}/api/surveys/${selectedSurveyId}/questions`,
        payload,
        {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        }
        );

        // ✅ 상태 초기화: 모든 필드 포함
        setNewQuestion({
        question_text: '',
        question_explain: '',
        question_type_id: '',
        options: [],
        max_score: 5,
        step: 0.5,
        required: false,
        includeEtc: false, // 기타 추가 여부 초기화
        correct_answer: '' // 정답 입력 초기화
        });

        // 🔄 새로고침
        selectSurvey(selectedSurveyId);
    } catch (err) {
        console.error('❌ 문항 추가 실패:', err);
        alert('문항 추가 중 오류가 발생했습니다.');
    }
};


    const addOptionToQuestion = async (questionId, optionText) => { //객관식 문항 추가
        try {
            const token = localStorage.getItem('token');
            await axios.post(
                `${API_BASE}/api/questions/${questionId}/options`,
                { option_text: optionText },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            selectSurvey(selectedSurveyId); // 옵션 추가 후 새로고침
        } catch (err) {
            console.error('❌ 옵션 추가 실패:', err);
            alert('옵션 추가 중 오류가 발생했습니다.');
        }
    };


    const updateQuestion = async (questionId, updatedData) => {
    try {
        const token = localStorage.getItem('token');
        
        // 서버로 보내기 전에 'correct_answer'를 포함한 업데이트 데이터 준비
        const updatedQuestion = {
            ...updatedData,
            correct_answer: updatedData.correct_answer || null,  // 'correct_answer'가 없다면 null로 설정
        };

        await axios.put(`${API_BASE}/api/questions/${questionId}`, updatedQuestion, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // 질문 업데이트 후 새로 고침
        await selectSurvey(selectedSurveyId);
        return true;
    } catch (err) {
        console.error('❌ 문항 수정 실패:', err);
        alert('수정 중 오류 발생');
        return false;
    }
};


    const deleteQuestion = async (questionId) => {
        try {
        const token = localStorage.getItem('token');
        await axios.delete(`${API_BASE}/api/questions/${questionId}`, {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        });
        selectSurvey(selectedSurveyId);
        } catch (err) {
        console.error('❌ 문항 삭제 실패:', err);
        alert('삭제 중 오류 발생');
        }
    };

    return (

        <div>
            
    <div className="top-right-button-group">
            <button onClick={() => navigate('/dashboard')} className="navigate-button">대시보드</button>
            <button onClick={() => navigate('/user')} className="navigate-button">
            평가단 관리
            </button>
            <button onClick={() => navigate('/site')} className="navigate-button">
            사이트 관리
            </button>
            <button onClick={() => navigate('/admin')} className="navigate-button primary">
            설문 관리
            </button>
            <button onClick={() => navigate('/responses')} className="navigate-button">
            응답 관리
            </button>
            <button onClick={() => navigate('/results')} className="navigate-button">
            통계 보기
            </button>
            <button onClick={() => navigate('/admin/login-notice')} className="navigate-button">로그인 공지 관리</button>
            <button onClick={handleLogout} className="navigate-button logout-button">
            로그아웃
            </button>
    </div>
        <div className="admin-container">

            <AdminSurveyManagePageLeft
            surveys={surveys}
            selectedSurveyId={selectedSurveyId}
            selectSurvey={selectSurvey}
            newSurvey={newSurvey}
            setNewSurvey={setNewSurvey}
            createSurvey={createSurvey}
            updateSurvey={updateSurvey} // ⬅️ 추가
            deleteSurvey={deleteSurvey} // ⬅️ 추가
            allSites={allSites} // ⬅️ 추가
            programs={programs}
            selectedProgram={selectedProgram}
            setSelectedProgram={setSelectedProgram}
            />

            {selectedSurveyId && (
            <AdminSurveyManagePageRight
                questions={questions}
                newQuestion={newQuestion}
                setNewQuestion={setNewQuestion}
                addQuestion={addQuestion}
                updateQuestion={updateQuestion}
                deleteQuestion={deleteQuestion}
                questionTypes={questionTypes}  // ✅ 추가!
                addOptionToQuestion={addOptionToQuestion} // ✅ 추가!
                setQuestions={setQuestions}
                selectSurvey={selectSurvey}
                selectedSurveyId={selectedSurveyId}    // ✅ 추가
            />
            )}
        </div>
        </div>
    );
};

export default AdminSurveyManagePage;
